import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const GENERIC_OK =
  "Şifre sıfırlama bağlantısı e-posta adresinize gönderildi. E-postayı gelen kutunuzda göremiyorsanız, lütfen Spam / Gereksiz Posta klasörünüzü de kontrol edin.";

export default function AdminForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/auth/forgot-password", {
        email: email.trim().toLowerCase(),
      });
    } catch {
      // Yanıt sabit — hesap var/yok bilgisi sızmaz.
    } finally {
      setLoading(false);
      setDone(true);
    }
  };

  return (
    <div
      className="min-h-screen bg-slate-950 text-white flex items-center justify-center p-6"
      data-testid="admin-forgot-password-page"
    >
      <div className="w-full max-w-sm bg-white/[0.04] border border-white/10 rounded-2xl p-8 backdrop-blur">
        <div className="flex items-center gap-2 mb-6">
          <img src="/penz-icon.png" alt="PENZ" className="w-9 h-9 rounded-lg bg-white/10 p-1 object-contain" />
          <div>
            <div className="font-display font-semibold">PENZ Yönetici</div>
            <div className="text-[11px] uppercase tracking-[0.2em] text-white/50">Şifremi Unuttum</div>
          </div>
        </div>

        {done ? (
          <div
            className="rounded-lg bg-white/5 border border-white/10 p-4 text-sm text-white/80"
            data-testid="admin-forgot-password-generic-message"
          >
            {GENERIC_OK}
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-forgot-password-form">
            <div className="space-y-1.5">
              <Label className="text-xs text-white/70">Admin E-posta</Label>
              <Input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-10 bg-white/5 border-white/15 text-white rounded-lg"
                required
                data-testid="admin-forgot-password-email-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-slate-900 hover:bg-slate-100 h-10 rounded-lg"
              data-testid="admin-forgot-password-submit-button"
            >
              {loading ? "Gönderiliyor..." : "Şifre Sıfırlama Bağlantısı Gönder"}
            </Button>
          </form>
        )}

        <div className="mt-6 text-center">
          <Link
            to="/admin/login"
            className="text-xs text-white/60 hover:text-white"
            data-testid="admin-forgot-password-back-to-login"
          >
            Admin girişine dön
          </Link>
        </div>
      </div>
    </div>
  );
}
